const MAX_IMAGE_URL_LENGTH = 2048;

const isLikelyDataUri = (value: string): boolean => value.trim().toLowerCase().startsWith('data:');

export const IMAGE_URL_ERROR_TOO_LONG =
  'Image link is too long. Please use a shorter URL or upload the file instead.';
export const IMAGE_URL_ERROR_DATA_URI =
  'Base64 data URLs are not supported here. Upload the file or host it at a public https:// link.';
export const IMAGE_URL_ERROR_INVALID = 'Enter a valid URL (including https://).';

/**
 * Validate raw image URL input before attempting to persist it.
 * Returns a human friendly error string if validation fails, otherwise null.
 */
export function validateImageUrl(rawValue: string | null | undefined): string | null {
  if (!rawValue) {
    return null;
  }

  const trimmed = rawValue.trim();
  if (!trimmed) {
    return null;
  }

  if (trimmed.length > MAX_IMAGE_URL_LENGTH) {
    return IMAGE_URL_ERROR_TOO_LONG;
  }

  if (isLikelyDataUri(trimmed)) {
    return IMAGE_URL_ERROR_DATA_URI;
  }

  try {
    new URL(trimmed);
  } catch {
    return IMAGE_URL_ERROR_INVALID;
  }

  return null;
}

export function isValidImageUrl(rawValue: string | null | undefined): boolean {
  return validateImageUrl(rawValue) === null;
}

export const IMAGE_URL_GUIDANCE =
  'Use a public https:// link (Google Drive share links work) or upload the image. Avoid very long or base64 data URLs.';
